import React from "react";
import { SmartForm} from './SmartForm'

export function ConsumeAsset() {
	const fields = [
		{
			label: "Username",
			name: "username",
			type: "text",
			regex: /^[a-zA-Z0-9_]{3,16}$/,
			exclusiveWith: ["wallet"]
		  },
		  {
			label: "Password",
			name: "password",
			type: "text",
		  },
			{
		  label: "Wallet",
		  name: "wallet",
		  type: "select",
		  options: [
			{ label: "Dr Grumpy", value: "0xd2Ad7F2aA6641586f88f3418AFACd591d67D24C3" },
			{ label: "Winner #1768", value: "0x77286f4b5f03665ef035fcdd62872b069c265862" }
		  ],
		  regex: /^0x[a-fA-F0-9]{4,}$/,
		  exclusiveWith: ["username"]
		},
		{
		  label: "Asset",
		  name: "asset",
		  type: "select",
		  options: ["Energy", "Gem Fighter", "HODLHAND"]
		},
		{
			label: "Qty",
			name: "qty",
			type: "text",
		},
		{
			label: "Source",
			name: "source",
			type: "text",
		},
		
	];
	  const endpoint = {
		"human" : "Consume Asset",
		"type" : "POST",
		"url" : "/ast/use",
	};
	
	return (
		<SmartForm fields={fields} endpoint = {endpoint} />
	);

}

export function AddAsset() {
	const fields = [
		{
			label: "Username",
			name: "username",
			type: "text",
			regex: /^[a-zA-Z0-9_]{3,16}$/,
			exclusiveWith: ["wallet"]
		  },
		  {
			label: "Password",
			name: "password",
			type: "text",
		  },
			{
		  label: "Wallet",
		  name: "wallet",
		  type: "select",
		  options: [
			{ label: "Dr Grumpy", value: "0xd2Ad7F2aA6641586f88f3418AFACd591d67D24C3" },
			{ label: "Winner #1768", value: "0x77286f4b5f03665ef035fcdd62872b069c265862" }
		  ],
		  regex: /^0x[a-fA-F0-9]{4,}$/,
		  exclusiveWith: ["username"]
		},
		{
		  label: "Asset",
		  name: "asset",
		  type: "select",
		  options: ["Energy", "Gem Fighter", "HODLHAND"]
		},
		{
			label: "Qty",
			name: "qty",
			type: "text",
		},
		{
			label: "Source",
			name: "source",
			type: "text",
		},
		
	];
	  const endpoint = {
		"human" : "Add Asset",
		"type" : "POST",
		"url" : "/ast/add",
	};
	
	return (
		<SmartForm fields={fields} endpoint = {endpoint} />
	);

}

export function GetAsset() {
	const fields = [
		{
			label: "Username",
			name: "username",
			type: "text",
			regex: /^[a-zA-Z0-9_]{3,16}$/,
			exclusiveWith: ["wallet"]
		  },
		  {
			label: "Password",
			name: "password",
			type: "text",
		  },
			{
		  label: "Wallet",
		  name: "wallet",
		  type: "select",
		  options: [
			{ label: "Dr Grumpy", value: "0xd2Ad7F2aA6641586f88f3418AFACd591d67D24C3" },
			{ label: "Winner #1768", value: "0x77286f4b5f03665ef035fcdd62872b069c265862" }
		  ],
		  regex: /^0x[a-fA-F0-9]{4,}$/,
		  exclusiveWith: ["username"]
		},
		{
		  label: "Asset",
		  name: "asset",
		  type: "select",
		  options: ["Energy", "Gem Fighter", "HODLHAND"]
		}
	  ];
	const endpoint = {
		"human" : "Check Asset",
		"type" : "GET",
		"url" : "/ast/holding",
	};
	
	return (
		<SmartForm fields={fields} endpoint = {endpoint} />
	);
};


